import * as React from 'react';

import {Box, Typography} from "@mui/material";

import BaBarre from "./BaBarre";
import {formatPercentage, getLabelFromNuance, getNomElection, tours, tours2} from "../../../Utils";

export function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}

export default function AnalyseElectionSerieLongue({candidat, otherResults}) {

    const [windowDimensions, setWindowDimensions] = React.useState(getWindowDimensions());


    if (otherResults) {
        return (
            <Box sx={{width: 'fit-content', display: "flex", flexDirection: "column", mb: 2, overflow: "auto"}}>
                <Box sx={{overflow: "auto", p: 2}}>
                    <Box sx={{display: "flex", flexDirection: "row"}}>
                        <Box sx={{
                            width: {md: 60, lg: 70, xl: 95},
                            border: "solid 1px #000", p: 1
                        }}>
                            &nbsp;
                        </Box>
                        {Object.keys(otherResults).map((date) => {
                            return Object.keys(otherResults[date]).map((election) => {
                                const fontWeight = election === "muni" ? "bold" : "normal";
                                return (<Box key={date + "_" + election} sx={{
                                    width: {md: 60, lg: 70, xl: 95},
                                    border: "solid 1px #000",
                                    p: 1,
                                    backgroundColor: "#e8eddf",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center"
                                }}>
                                    <Typography sx={{
                                        fontWeight: fontWeight,
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                    }}>{getNomElection[election]}</Typography>
                                    <Typography sx={{
                                        fontWeight: fontWeight,
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                    }}>{date}</Typography>
                                </Box>)
                            })
                        })}
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "row"}}>
                        <Box sx={{width: {md: 60, lg: 70, xl: 95}, border: "solid 1px #000", p: 1}}>
                            <Typography sx={{
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                            }}>{tours2["t1"]}</Typography>
                            <Typography sx={{
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                            }}>Nuance po.</Typography>
                        </Box>
                        {Object.keys(otherResults).map((date) => {

                            return Object.keys(otherResults[date]).map((election) => {
                                let info = otherResults[date][election];
                                let value2 = ""
                                let value = ""
                                let perc = ""
                                let voix = ""
                                if (candidat) {
                                    if (info["t1"] && info["t1"].candidats) {

                                        let winner = null;
                                        let nb = 0;
                                        Object.keys(info["t1"].candidats).forEach((election) => {
                                            if (winner === null || info["t1"].candidats[election].r > winner.r) {
                                                winner = info["t1"].candidats[election]
                                            }
                                            nb += info["t1"].candidats[election].r
                                        })
                                        value = winner.nuance
                                        value2 = winner.nuance
                                        if (winner.perc) {
                                            perc = formatPercentage(winner.perc)
                                            voix = winner.r + " voix"
                                        } else {

                                            perc = formatPercentage(winner.r / nb)
                                            voix = winner.r + " voix"
                                        }
                                    }
                                } else {
                                    if (info["t1"] && info["t1"].nuances) {

                                        let winner = null;
                                        Object.keys(info["t1"].nuances).forEach((election) => {
                                            if (winner === null || info["t1"].nuances[election].perc > winner.perc) {
                                                winner = info["t1"].nuances[election]
                                            }
                                        })

                                        value = winner.nuance
                                        value2 = winner.nuance
                                        perc = formatPercentage(winner.perc)
                                        voix = winner.r + " voix"
                                    }
                                }
                                return (<Box key={date + "_" + election}
                                             sx={{
                                                 width: {md: 60, lg: 70, xl: 95},
                                                 border: "solid 1px #000",
                                                 color: "white",
                                                 p: 1,
                                                 backgroundColor: getLabelFromNuance(value2, date).color,
                                                 display: "flex",
                                                 flexDirection: "column",
                                                 alignItems: "center"
                                             }}>
                                    <Typography sx={{
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                    }}>{value}</Typography>
                                    <Typography sx={{
                                        mt: 0.5,
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                    }}>{perc}</Typography>
                                    <Typography sx={{
                                        mt: 0.8,
                                        fontSize: {md: "8px", lg: "10px", xl: "12px"},
                                        lineHeight: {md: "8px", lg: "10px", xl: "12px"}
                                    }}>{voix}</Typography>

                                </Box>)
                            })
                        })}
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "row"}}>
                        <Typography sx={{
                            width: {md: 60, lg: 70, xl: 95},
                            border: "solid 1px #000", p: 1,
                            fontSize: {md: "10px", lg: "12px", xl: "16px"},
                            lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                        }}>
                            Abstention
                        </Typography>
                        {Object.keys(otherResults).map((date) => {
                            return Object.keys(otherResults[date]).map((election) => {
                                let info = otherResults[date][election];
                                let value = ""

                                if (info["t1"]) {

                                    value = info["t1"].abs / info["t1"].ins
                                    value = formatPercentage(value)
                                }
                                return (<Box key={date + "_" + election}
                                             sx={{
                                                 width: {md: 60, lg: 70, xl: 95},
                                                 border: "solid 1px #000",

                                                 p: 1,
                                                 display: "flex",
                                                 flexDirection: "column",
                                                 alignItems: "center"
                                             }}>
                                    <Typography sx={{
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                    }}>{value}</Typography>
                                </Box>)
                            })
                        })}
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "row"}}>
                        <Box sx={{width: {md: 60, lg: 70, xl: 95}, border: "solid 1px #000", p: 1}}>
                            <Typography sx={{
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                            }}>{tours2["t2"]}</Typography>
                            <Typography sx={{
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                            }}>Nuance po.</Typography>
                        </Box>
                        {Object.keys(otherResults).map((date) => {
                            return Object.keys(otherResults[date]).map((election) => {
                                let info = otherResults[date][election];
                                let value = ""
                                let value2 = ""
                                let perc = ""
                                let voix = ""
                                if (candidat) {
                                    if (info["t2"] && info["t2"].candidats) {

                                        let winner = null;
                                        let nb = 0;
                                        Object.keys(info["t2"].candidats).forEach((election) => {
                                            if (winner === null || info["t2"].candidats[election].r > winner.r) {
                                                winner = info["t2"].candidats[election]
                                            }
                                            nb += info["t2"].candidats[election].r
                                        })
                                        value = winner.nuance
                                        value2 = winner.nuance
                                        if (winner.perc) {
                                            perc = formatPercentage(winner.perc)
                                            voix = winner.r + " voix"
                                        } else {

                                            perc = formatPercentage(winner.r / nb)
                                            voix = winner.r + " voix"
                                        }

                                    }
                                } else {
                                    if (info["t2"] && info["t2"].nuances) {

                                        let winner = null;
                                        Object.keys(info["t2"].nuances).forEach((election) => {
                                            if (winner === null || info["t2"].nuances[election].perc > winner.perc) {
                                                winner = info["t2"].nuances[election]
                                            }
                                        })

                                        value = winner.nuance
                                        value2 = winner.nuance
                                        perc = formatPercentage(winner.perc)
                                        voix = winner.r + " voix"
                                    }
                                }
                                return (<Box key={date + "_" + election}
                                             sx={{
                                                 width: {md: 60, lg: 70, xl: 95},
                                                 border: "solid 1px #000",
                                                 color: "white",
                                                 p: 1,
                                                 backgroundColor: getLabelFromNuance(value2).color,
                                                 display: "flex",
                                                 flexDirection: "column",
                                                 alignItems: "center"
                                             }}>
                                    <Typography sx={{
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                    }}>{value}</Typography>
                                    <Typography sx={{
                                        mt: 0.5,
                                        fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                        lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                    }}>{perc}</Typography>
                                    <Typography sx={{
                                        mt: 0.8,
                                        fontSize: {md: "8px", lg: "10px", xl: "12px"},
                                        lineHeight: {md: "8px", lg: "10px", xl: "12px"}
                                    }}>{voix}</Typography>
                                </Box>)
                            })
                        })}
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "row"}}>
                        <Typography sx={{
                            fontSize: {md: "10px", lg: "12px", xl: "16px"},
                            lineHeight: {md: "10px", lg: "12px", xl: "16px"},
                            width: {md: 60, lg: 70, xl: 95},

                            border: "solid 1px #000", p: 1
                        }}>

                            Abstention
                        </Typography>
                        {Object.keys(otherResults).map((date) => {
                            return Object.keys(otherResults[date]).map((election) => {
                                let info = otherResults[date][election];
                                let value = ""

                                if (info["t2"]) {

                                    value = info["t2"].abs / info["t2"].ins
                                    value = formatPercentage(value)
                                }
                                return (<Box key={date + "_" + election}
                                             sx={{
                                                 width: {md: 60, lg: 70, xl: 95},
                                                 border: "solid 1px #000",
                                                 p: 1,
                                                 display: "flex",
                                                 flexDirection: "column",
                                                 alignItems: "center"
                                             }}>
                                    <Typography
                                        sx={{
                                            fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                            lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                        }}>{value}</Typography>
                                </Box>)
                            })
                        })}
                    </Box>
                </Box>
            </Box>

        );
    }
}
